if (!customElements.get('lazy-video')) {
	customElements.define('lazy-video', class LazyVideo extends HTMLElement {
	  constructor() {
		super();
		this.video = this.querySelector('video');
		this.lazyVideoObserver(this.video)
	  }
  
	  lazyVideoObserver(lazyVideo) {
		const lazyVideoObserver = new IntersectionObserver((entries, observer) => {
		  entries.forEach(video => {
			if (video.isIntersecting) {
			  for (let source in video.target.children) {
				const videoSource = video.target.children[source];
				if (typeof videoSource.tagName === 'string' && videoSource.tagName === "SOURCE") {
				  if (videoSource.hasAttribute('data-src')) {
					videoSource.src = videoSource.dataset.src;
				  }
				}
			  }
  
			  video.target.load();
			  lazyVideoObserver.unobserve(video.target);
			}
		  })
		})
  
		lazyVideoObserver.observe(lazyVideo);
	  }
	})
  }
  